import {
  Button,
  Card,
  CardBody,
  FormControl,
  FormLabel,
  Input,
  Select,
  Text,
  VStack,
} from '@chakra-ui/react';
import type React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { PositionsEntityKind } from '@revelio/data-access';

import { FieldGroup } from '../../shared/ui/admin/groups/field/field-group';
import DashboardPage from '../DashboardPage';

const ENTITY_TYPES = Object.values(PositionsEntityKind);

export const EntitySearch = () => {
  const [entityType, setEntityType] = useState('');
  const [entityIds, setEntityIds] = useState('');

  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (entityType && entityIds.trim()) {
      // Parse and validate entity IDs
      const parsedIds = entityIds
        .split(',')
        .map((id) => id.trim())
        // biome-ignore lint/suspicious/noGlobalIsNan: migrated from develop
        .filter((id) => id && !isNaN(Number(id)))
        .map((id) => Number(id));

      if (parsedIds.length > 0) {
        navigate(`/tools/find/${entityType}/${parsedIds.join(',')}`);
      }
    }
  };

  return (
    <DashboardPage title="Entity Search" backPath="/tools">
      <Card w="100%">
        <CardBody>
          <FieldGroup
            title="Search Criteria"
            description="Search for entities by type and ID(s). Enter multiple IDs separated by commas."
          >
            <form onSubmit={handleSubmit}>
              <VStack spacing={4} align="start">
                <FormControl isRequired>
                  <FormLabel fontSize="sm">Entity Type</FormLabel>
                  <Select
                    placeholder="Select entity type"
                    value={entityType}
                    onChange={(e) => setEntityType(e.target.value)}
                  >
                    {ENTITY_TYPES.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl isRequired mb={4}>
                  <FormLabel fontSize="sm">Entity ID(s)</FormLabel>
                  <Input
                    type="text"
                    placeholder="Enter entity ID(s)"
                    value={entityIds}
                    onChange={(e) => setEntityIds(e.target.value)}
                    mb={1}
                  />
                  <Text fontSize="sm" color="gray.600">
                    Enter multiple IDs separated by commas.
                  </Text>
                </FormControl>

                <Button
                  type="submit"
                  width="100%"
                  size="lg"
                  colorScheme="navyBlue"
                >
                  View Entities
                </Button>
              </VStack>
            </form>
          </FieldGroup>
        </CardBody>
      </Card>
    </DashboardPage>
  );
};
